package com.appsyde.contract.recommended

/**
 * Poids P0/P1/P2 pour les clés (Spec §5). Seul P0 pilote l'action recommandée.
 */
enum class Weight { P0, P1, P2 }
